import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
    ModalItem,
    Form,
    FormItem,
    InputItem,
    InputNumberItem,
    HeaderItem,
    BoxItem,
    ButtonItem,
    TextAreaItem,
} from "../../../../Components/Items";
import { Row, Col, message } from "antd";

class EditarUbicacion extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        nombreProyecto: "",
    };

    componentDidMount() {
        if (this.props.ubicacion) {
            this.formRef.current?.setFieldsValue(this.props.ubicacion);
            this.consultarNombreProyecto(this.props.ubicacion.proyectoId);
        }
    }
    componentDidUpdate(prevProps) {
        // Si cambió la ubicación seleccionada, actualiza los campos y el nombre del almacén
        if (
            this.props.ubicacion &&
            this.props.ubicacion._id !== prevProps.ubicacion?._id
        ) {
            this.formRef.current?.setFieldsValue(this.props.ubicacion);
            this.consultarNombreProyecto(this.props.ubicacion.proyectoId);
        }
    }

    consultarNombreProyecto(proyectoId) {
        if (!proyectoId) return;
        const { empresaId, headersToken } = this.props;

        axios
            .post(
                "proyectos/datosProyecto",
                { proyectoId, empresaId },
                { headers: headersToken }
            )
            .then((res) => {
                if (res.data && res.data.nombre) {
                    this.setState({ nombreProyecto: res.data.nombre });
                }
            })
            .catch(() => {
                console.error("Error al obtener los datos del almacén");
                this.setState({ nombreProyecto: "No disponible" });
            });
    }

    atras() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    onFinishFailed() {
        message.error("Verifica los campos obligatorios.");
    }

    onFinish(values) {
        this.setState({ loading: true });

        axios
            .post(
                "ubicacionProyecto/editarUbicacionProyecto",
                {
                    ...values,
                    _id: this.props.ubicacion._id,
                    empresaId: this.props.empresaId,
                    proyectoId: this.props.proyectoId,
                    usuarioId: this.props.usuarioId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Ubicación actualizada correctamente");
                    if (this.props.onClose) this.props.onClose();
                } else {
                    message.error(res.data.message || "No se pudo actualizar la ubicación");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al actualizar la ubicación");
            });
    }

    render() {

        return (
            <ModalItem
                title="Editar Ubicación"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.atras.bind(this)}
                paddingTop
                width={800}
            >
                <HeaderItem>ALMACÉN: {this.state.nombreProyecto}</HeaderItem>

                <Form
                    ref={this.formRef}
                    name="editarUbicacion"
                    layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Guardar cambios
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <HeaderItem>DATOS DE LA UBICACIÓN</HeaderItem>
                        <BoxItem>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <FormItem label="Clave" name="clave" required margin>
                                        <InputItem placeholder="Clave" />
                                    </FormItem>
                                    <FormItem label="Nombre" name="nombre" required margin>
                                        <InputItem placeholder="Nombre" />
                                    </FormItem>
                                    <FormItem label="Descripción" name="descripcion" margin>
                                        <TextAreaItem placeholder="Descripción" />
                                    </FormItem>
                                    <FormItem label="Secuencia" name="secuencia" margin numberCero>
                                        <InputNumberItem placeholder="Secuencia" />
                                    </FormItem>
                                    <FormItem label="Secuencia Recorrido" name="secuenciaRecorrido" margin number>
                                        <InputNumberItem placeholder="Secuencia Recorrido" />
                                    </FormItem>
                                    <FormItem label="Cantidad Máxima" name="cantidadMaxima" margin numberCero>
                                        <InputNumberItem placeholder="Cantidad Máxima" />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Ancho" name="ancho" margin numberCero tooltip="La medida esta en metros.">
                                        <InputNumberItem placeholder="Ancho (mts)" />
                                    </FormItem>
                                    <FormItem label="Alto" name="alto" margin numberCero tooltip="La medida esta en metros.">
                                        <InputNumberItem placeholder="Alto (mts)" />
                                    </FormItem>
                                    <FormItem label="Largo" name="largo" margin numberCero tooltip="La medida esta en metros.">
                                        <InputNumberItem placeholder="Largo (mts)" />
                                    </FormItem>
                                    <FormItem label="Número Rack" name="numeroRack" margin numberCero>
                                        <InputNumberItem placeholder="Número Rack" />
                                    </FormItem>
                                    <FormItem label="Nivel Rack" name="nivelRack" margin numberCero>
                                        <InputNumberItem placeholder="Nivel Rack" />
                                    </FormItem>
                                    <FormItem label="Observaciones" name="observaciones" margin>
                                        <TextAreaItem placeholder="Observaciones" />
                                    </FormItem>
                                </Col>
                            </Row>
                        </BoxItem>
                    </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa?.id,
    usuarioId: state.user?.id,
});

export default connect(mapStateToProps)(EditarUbicacion);
